"use strict";

const validator = require("validator");

window.__storeProduct = (product) => {

	const templates = {
		'size-button': $.templates('#template-size-button'),
		'variationFragment': $.templates('#template-variationFragment'),
		'variationOption': $.templates('#template-variationOption'),
		'variationFullOptionMini': $.templates('#template-variationFullOptionMini'),
		'addCartConfirmation': $.templates('#template-addToCartConfirmation'),
		'lowStockNotice': $.templates('#template-lowStockNotice'),
		'productImageZoomModal': $.templates('#template-productImageZoomModal'),
	}

	const sizeVariationIndex = product.variations.findIndex(v => v.variation.isSize);
	const sizeVariation = product.variations.find(v => v.variation.isSize)
	const availableSizes = [];
	const priceRange = {min:product.basePrice, max:product.basePrice};
	const preSelectedItem = selectedSKU ? product.stock.find(x => x.SKU === selectedSKU) : null;

	const getVariation = (index) => {
		product.variations[index].variation.optionsAvailable = product.variations[index].optionsAvailable;

		return product.variations[index].variation;
	};
	const getStockLinesByVariationGroup = (variationIndex, variationMatch) => product.stock.filter(x => x.map[variationIndex] == variationMatch);
	const getAvailableStockLinesByVariationGroup = (variationIndex, variationMatch) => getStockLinesByVariationGroup(variationIndex, variationMatch).filter(x => x.display !== false);
	
	const enableAddCart = () => $('.addCartGroup .btn, .addCartGroup input').removeClass('disabled').prop("disabled", false);
	const disableAddCart = () => {
		$('.addCartGroup .btn, .addCartGroup input').addClass('disabled').prop("disabled", true);
		$('.addCartGroup input').val('');
	}

	const attachToAddCart = (SKU, amount) => {
		$('.btn.addToCart').data("sku", SKU);
		$('.btn.addToCart').data("amount", amount);
	} 

	const validateGiftcardField = ($field) => {
		let fieldName = $field.attr('name');

		$field.val($field.val().trim());
		
		let fieldVal = $field.val();

		let validateFx;
		let returnStr = '';

		let maxLength;

		switch (fieldName) {
			case "gc_sender_name":
			case "gc_recipient_name":
				validateFx = validator.isAscii;
				returnStr = "Please enter valid characters";
				maxLength = 64;
				break;
			case "gc_sender_email":
			case "gc_recipient_email":
				validateFx = validator.isEmail;
				returnStr = "Please enter a valid email address";
				maxLength = 256;
				break;
			case "gc_gift_message":
				validateFx = validator.isAscii;
				returnStr = "Please enter valid characters";
				maxLength = 512;
				break;
		}

		if (!validateFx) {
			console.info(`No validation function found for ${fieldName}`)
		} else if (validateFx && !validateFx(fieldVal)) {
			return returnStr;
		} else if (maxLength && maxLength != -1 && fieldVal.length > maxLength) {
			return `Too long! There is a maximum of ${maxLength} characters for this field.`;
		}

		return "";
	}

	const runGiftcardValidationAndUIUpdate = ($field) => {
		$field.removeClass('is-invalid is-valid');

		let error = validateGiftcardField($field);

		if (error.length > 0) {
			$field.addClass('is-invalid');
			$field.next('.invalid-feedback').text(error);
		} else {
			$field.addClass('is-valid');
			$field.next('.invalid-feedback').text('');
		}

		return error;
	}

	const redrawPageForOption = (option) => {
		const data = option && typeof option.data == "function" ? option.data() : option;
		const isVariation = ( data && data.variationNames.length > 0 );
		const variationPrice = (data && data.price ? data.price : product.basePrice);
		const entitlementSelection = $('body').data('entitlementObject');
		const entitlementOption = $('body').data('entitlementOption');
		const isEntitlementSelected = (entitlementSelection || entitlementOption);

		let priceRangeText = '';
		let buyPriceText = '';
		let rangeText = '';
		let intervalLabelText = '';
		if (product.isGiftcard === true) {
			// calculate the total price

			const $plan = $("#gc_plans option:selected");
			const $interval = $('#gc_interval option:selected');
			const length = $('#gc_length option:selected').val();

			const planData = $plan.data();
			const $featureList = $('.giftcard_description ul');

			const price = (($interval.data('amount') * length) / 100).toFixed(2);
		
			$(".priceLabel").text(`$${price}`);
			$(".shippingNotice").text('Digitally Delivered');

			const adminCountLabel = 'Allows <strong>' + (planData.featuresMaxAdmins === -1 ? '<strong>UNLIMITED</strong>' : planData.featuresMaxAdmins) + ' additional administrator'+(planData.featuresMaxAdmins === 1 ? '' : 's') + '</strong> to assist in directing scenes';
			const maxSpectatorLabel = (planData.featuresMaxSpectators === -1 ? '<strong>UNLIMITED</strong>' : 'Up to <strong>' + planData.featuresMaxSpectators) + ' actor'+(planData.featuresMaxSpectators === 1 ? '' : 's')+"</strong> concurrently connected to the gift recipient's lobbies";
			const maxLobbyLabel = (planData.featuresConcurrentPresentations === -1 ? '<strong>UNLIMITED</strong>' : 'Host up to <strong>' + planData.featuresConcurrentPresentations) + ' concurrent presentation'+(planData.featuresConcurrentPresentations === 1 ? '' : 's')+"</strong>";
			
			$featureList.empty();

			if (planData.featuresMaxAdmins !== 0) {
				$featureList.append(`<li>${adminCountLabel}</li>`);
			}

			$featureList.append(`<li>${maxSpectatorLabel}</li>`);
			$featureList.append(`<li>${maxLobbyLabel}</li>`);

			planData.description.split("\n").forEach(line => {
				$featureList.append(`<li>${line}</li>`);
			});

			return;
		}

		let priceLabelText = '';

		let possiblePrices = [];

		if (priceRange.min !== priceRange.max) {
			priceRangeText = `$${(priceRange.min/100).toFixed(2)} - $${(priceRange.max/100).toFixed(2)}`;
		}

		if (product.isBuyable) {
			buyPriceText = `$${((data && data.price ? data.price : product.basePrice)/100).toFixed(2)}`;
			
			if (isVariation) {
				possiblePrices = [...possiblePrices, variationPrice];
			} else {
				possiblePrices = [...possiblePrices, product.basePrice];
			}

			if (product.isRentable) {
				intervalLabelText = `with rental options`;
			}
		}

		if (product.isRentable) {
			possiblePrices = [ ...possiblePrices, ...product.rentalFeeSchedule.map(x => x.price)]
		}

		// calculate scoped price range
		let scopedPriceRange = {min: Infinity, max: -Infinity};
		
		possiblePrices.forEach(x => {
			if (x < scopedPriceRange.min) {
				scopedPriceRange.min = x;
			}
			if (x > scopedPriceRange.max) {
				scopedPriceRange.max = x;
			}
		});

		if (scopedPriceRange.min !== scopedPriceRange.max) {
			priceRangeText = `$${(scopedPriceRange.min/100).toFixed(2)} - $${(scopedPriceRange.max/100).toFixed(2)}`;
		}


		if (isEntitlementSelected || true) {
			if (entitlementOption === "buy" || true) {
				priceLabelText = buyPriceText;
				intervalLabelText = "";
			} else {
				priceLabelText = entitlementSelection.priceLabel;
				intervalLabelText = entitlementSelection.intervalLabel;
			}
		} else {
			
			priceLabelText = !isVariation ? priceRangeText : buyPriceText;
		}

		if (!product.isSingleton && data && data.amount < 10 && data.amount !== 0)  {
			let $notice = $(templates.lowStockNotice.render(data));
			$('.lowStockAlertContainer').html($notice);
		} else {
			$('.lowStockAlertContainer').html('');
		}

		if (!priceLabelText) {
			priceLabelText = rangeText;
		}

		if ($('.buyOptionGroupItem input[type="radio"]').length > 1) {
			$('.buyOptionGroup').show();
		}

		$(".priceDescriptor .priceLabel").text(priceLabelText);
		$(".buyOptionGroup .priceLabel").text(buyPriceText);
		$(".intervalNotice").text(intervalLabelText);

		$('.productSubtitle').empty();
		$('img.preview_image').attr('src', data && data.previewimage ? data.previewimage : product.image_map.main);

		// a variation is selected
		if (isVariation) {
			data.variationNames.forEach((name,index) => {
				$('.productSubtitle').append($(`<span>${name}${(index+1 !== data.variationNames.length ? ', ' : '')}</span> `))
			});

		}

	}

	const renderMiniProductOption = (stockLine) => {
		const data = stockLine;
		data.size = '';
		data.label = '';
		data.variationNames = [];

		stockLine.map.forEach((index,thisVariationIndex) => {
			let labelText = getVariation(thisVariationIndex).optionsAvailable[index].label;
			data.variationNames.push(labelText);

			if (thisVariationIndex === sizeVariationIndex) {
				data.size = labelText;
			} else {
				data.label += labelText+"\n";
			}
		})

		data.label = data.label.trim().split("\n").join("\n<br>");
		data.product = product;

		const accessibilityLabel = `Click to view the '${data.variationNames.join(' ')}' variation of '${data.product.name}.'`;

		const $render = $(templates.variationFullOptionMini.render(data));
		const $renderLink = $render.find('a.variationComboImageContainer');

		if (!$renderLink.attr('href') && $renderLink.attr('desturl')) {
			$renderLink.attr('href', $renderLink.attr('desturl'));
			$renderLink.attr('desturl', null);
		}

		$renderLink.attr('title', accessibilityLabel);
		$renderLink.attr('aria-label', accessibilityLabel);

		$renderLink.find('img').attr('title', accessibilityLabel);
		$renderLink.find('img').attr('aria-label', accessibilityLabel);

		for(let prop in data) {
			$render.data(prop, data[prop]);
		}

		$render.find('.variationComboImageContainer').on('click', function(e) {
			e.preventDefault();

			const data = $(this).parent().data();
			$('body').data('currentOptionSelection', data);
			redrawPageForOption($render)
			
			$render.removeClass('not-selected');
			$render.siblings().addClass('not-selected');
			
			if (!$render.hasClass('sold-out')) {
				enableAddCart();
				attachToAddCart(data.SKU, data.amount);
				$('.addToCart').removeClass('btn-danger')
			} else {
				disableAddCart();
				$('.addToCart').addClass('btn-danger');
			}

			$('.addCartGroup .quantity').val('');
			let title = (product.name + (data.variationNames.length > 0 ? ' - ' + data.variationNames.join(', ') : '') + ' - ActorsBible');
			$('head title').text(title);

			if (!$('body').data('popstate')) {
				history.pushState({item: data, SKU: data.SKU}, title, `${linkUrl}/${data.SKU}`);
			}
		});

		$render.find('.variationComboImageContainer').on('mouseover', () => redrawPageForOption($render));

		$render.find('.variationComboImageContainer').on('mouseout', () => redrawPageForOption($('body').data('currentOptionSelection')));

		return $render;
	}

	$(window).on("popstate", e => {

		if (!e.originalEvent.state) {
			console.log(e);
			return false;
			history.back();
			return;
		}

		const item = e.originalEvent.state.item;
		
		if (!item || !item.SKU) {
			return;
		}

		$('body').data('popstate', true);
		/// trace it through and click the size, etc.
		if (sizeVariationIndex !== -1) {
			let localSizeVariationValue = item.map[sizeVariationIndex];
			let localSizeVariationObject = product.variations[sizeVariationIndex].optionsAvailable[localSizeVariationValue];

			$(`.storeSizeButton[data-option-id="${localSizeVariationObject._id}"]`).trigger('click');
		}
		
		$(`.variationItem[data-sku="${item.SKU}"] .variationComboImageContainer`).trigger('click');

		$('body').data('popstate', false);
	});

	// figure out the price range (some)

	if (product.isBuyable) {
		product.stock.filter(s => s.display !== false && s.amount > 0 && s.price).forEach(s =>{
			if (s.price < priceRange.min) {
				priceRange.min = s.price;
			}

			if (s.price > priceRange.max) {
				priceRange.max = s.price;
			}
		})
	}

	if (product.isRentable) {
		product.rentalFeeSchedule.forEach(s =>{
			if (s.price < priceRange.min) {
				priceRange.min = s.price;
			}

			if (s.price > priceRange.max) {
				priceRange.max = s.price;
			}
		})
	}

	 if (priceRange.min !== priceRange.max) {
		 $('.priceDescriptor .priceLabel').text(`$${(priceRange.min/100).toFixed(2)} - $${(priceRange.max/100).toFixed(2)}`);
	 }
	// figure out what sizes we have available
	if (sizeVariationIndex !== -1) {

		$('#sizeRegion').show();

		disableAddCart();

		$('.buyOptionGroup').hide();

		sizeVariation.optionsAvailable.forEach((option, key) => {
			if (product.stock.find(x => x.map[sizeVariationIndex] === key && x.display && x.amount > 0)) {
				availableSizes.push(option);

				let $sizeBtn = $(templates['size-button'].render(option));

				$sizeBtn.on('click', function(e) {
					let $this = $(this);
					let $btn = $this.find('.storeSizeButton');

					$('.storeSizeButton.selected').removeClass('selected');

					$btn.addClass('selected');

					// find original index.
					const id = $btn.data('option-id');
					const optionIndex = sizeVariation.optionsAvailable.findIndex(option => option._id == id);
					const availableItems = getAvailableStockLinesByVariationGroup(sizeVariationIndex, optionIndex);
					const currentSelection = $('body').data('currentOptionSelection');

					$('.variationContainer').empty();
					
					availableItems.forEach(item => {
						let $render = renderMiniProductOption(item);

						if (item.amount < 1) {
							$render.addClass('sold-out');
						}

						if (currentSelection && currentSelection._id !== $render.data('_id')) {
							$render.addClass('not-selected');
						}

						$('.variationContainer').append($render);

						// if there's only one item, simulate a click on it to automatically select it
						if (availableItems.length === 1) {
							$render.find('.variationComboImageContainer').trigger('click');
						}
					})


				});

				$('.sizeContainer').append($sizeBtn);

				// if this is the size of the pre-selected button, click it.
				if (preSelectedItem && preSelectedItem.map[sizeVariationIndex] === key) {
					$sizeBtn.click();
				}
			}
		})


		// if only one size button was generated, expand it.

		if ($('.sizeContainer .storeSizeButton').length === 1) {
			$('.sizeContainer .storeSizeButton').click();
		}

		if ($('.variationComboImageContainer').length === 0) {
			$('.variationComboImageContainer').click();
		}


		// if they have a preselected item (from URL), trace it through.
		if (selectedSKU) {
			$('body').data('popstate', true);
			$(`.variationItem[data-sku="${selectedSKU}"] .variationComboImageContainer`).click();
			$('body').data('popstate', false);
		}
	} else {
		let availableProducts = product.stock.filter(sL => sL.display)
		// We have no sizes, so we need to just render all variations (if there are any)
		if (availableProducts.length > 1) {
			availableProducts.forEach(item => $('.variationContainer').append(renderMiniProductOption(item)))

			if (selectedSKU) {
				$(`.variationItem[data-sku="${selectedSKU}"] .variationComboImageContainer`).click();
			}
		}
		else if (availableProducts.length === 1) {
			const dataSet = availableProducts[0];
			dataSet.images = product.images;
			dataSet.image_map = product.image_map;

			let $render = renderMiniProductOption(availableProducts[0]);
			redrawPageForOption($render);

			// if this is a variation type product, show in the list 
			if (availableProducts[0].map.length > 0) {
				$('.variationContainer').append($render);
			}

			if (product.variations.length === 0) {
				attachToAddCart(product.SKUPrefix, product.stock[0].amount);

				if (product.stock[0].amount === 0) {
					$('.addToCart').prop('disabled', true).addClass('btn-danger').addClass('disabled');

					$('.lowStockAlertContainer').html('<div class="alert alert-danger">This item is sold out.</div>')
				} else if (!product.isSingleton && product.stock[0].amount < 10) {
					$('.lowStockAlertContainer').html($(templates.lowStockNotice.render()));
				}
			}
			$('.variationComboImageContainer').click();
		
		}
	}

	$("#gc_length").on('change', function() {
		redrawPageForOption();
	});

	$("#gc_interval").on('change', function() {
		const $this = $(this);
		const $lengthField = $("#gc_length");

		const currentValue = parseInt($lengthField.find('option:selected').val());

		// empty out the options
		$lengthField.find('option').remove();


		// years have max of 2 years, months have maximum of 11 months
		const maximumTerm = $this.find('option:selected').data('interval') === 'month' ? 11 : 3;

		for (let x = 1; x <= maximumTerm; x++) {
			const $option = $('<option>', {
				value: x,
				text: x + ' ' + $this.find('option:selected').data('interval') + (x > 1 ? 's' : ''),
				selected: x === currentValue
			});

			
			$lengthField.append($option);
		}
		$lengthField.trigger('change');
	})

	if (product.isGiftcard) {
		$('.gc_plans').on('change', function() {
			const $this = $(this);
			const $selected = $this.find('option:selected');
			const groupName = $selected.data('planName');

			const currentlySelectedInterval = $("#gc_interval option:selected").data('interval');
			
			// hide any plans that don't match the selected group name
			$('#gc_interval option').each(function() {
				const $elem = $(this);

				if ($elem.data('planName') !== groupName) {
					$elem.hide();
				} else {
					$elem.show();

					// find the analogous interval for the selected plan
					if ($elem.data('interval') === currentlySelectedInterval) {
						$elem.prop('selected', true);
					}
				}
			});

			$("#gc_interval").trigger('change');

		}).trigger('change');


		let $giftcardFields = $('.giftcard_options .gift-tag .form-control');
		let $giftcardFieldGroups = $('.giftcard_options .form-group');

		$giftcardFields.on('blur', function() { runGiftcardValidationAndUIUpdate($(this)) });
		$giftcardFields.on('keyup', function() { 
			$(this).removeClass('is-invalid is-valid'); 
		});

		$('.addToCart').data('giftcardProductOptions', $('.giftcard_options .product-options .form-control'))
		$('.addToCart').data('giftcardFields', $giftcardFields);
		$('.addToCart').data('giftcardValidateFx', runGiftcardValidationAndUIUpdate);

		attachToAddCart(product.SKUPrefix, 1);
	}

	$('.addToCart').data('success-callback', (data) => {
		if (data.quantity === 0) {
			return;
		}
		let $notification = $(templates.addCartConfirmation.render(data));
		$notification.hide();

		$('.addConfirmationContainer').append($notification);
		$notification.fadeIn();

		setTimeout(() => $notification.fadeOut(), 3500);
	})

	$('.buyOptionGroupItem input[type="radio"]').on('click', function(event) { 
		let $this = $(this);
		let value = $this.val();

		$('body').data('entitlement-option', value)

		if (value === 'buy') {
			$('body').data('entitlement-object', null);
		} else {
			$('body').data('entitlement-object', product.rentalFees.find(fee => fee._id === value));
		}

		redrawPageForOption($('body').data('currentOptionSelection'));
	});

	if ($('.buyOptionGroupItem input[type="radio"]').length === 1) {
		$(".buyOptionGroup").hide();
		$('.buyOptionGroupItem input[type="radio"]').trigger('click');
	};

	$('.preview_image').on('click', function() {
		const $this = $(this);
		const imageURL = $this.attr('src');
		const imageURL_split = imageURL.split('/');
		const extension = imageURL.split(".").pop();
		
		imageURL_split.pop();


		// look for an existing modal, and destroy it
		$('.productImageModalWrapper').remove();
		
		const $modal = $(templates.productImageZoomModal.render({alt:product.name, image_url: `${imageURL_split.join("/")}/expanded.${extension}`}));

		const $modalContainer = $modal.find('.modalContainer');
		const $modalBody = $modal.find('.modalBody');
		const $image = $('.right-pane .preview_image');

		
		$modal.find('.close-box').on('click', function() {
			$modal.remove();
		});
		
		$('body').append($modal);
		
		$modalBody.css('line-height', $modalBody.height() + 'px');
		$modalContainer.css('aspect-ratio', `${$image.width()} / ${$image.height()}`);
	});

	$('head title').text(product.name + (preSelectedItem ? ' - ' + preSelectedItem.variationNames.join(', ') : '') + ' - ActorsBible')
}